import React from 'react';

export const CheckboxSquarePrimaryPartialIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="20" height="20" rx="5" fill="#774EFF" />
      <rect x="3" y="9" width="14" height="2" rx="1" fill="white" />
    </svg>
  );
};
